import styled, { AnyStyledComponent, css } from 'styled-components'
import { tabletBreakpoint } from 'react-components'

import { FilterHeadPosition } from '../types'
import NewTagStarIcon from '../../../../assets/icons/filter-icons/star.svg'
import ChevronDownIcon from '../../../../assets/icons/grey-chevron-down.svg'

interface ContainerProps {
    isActive: boolean
    isFilterSelected: boolean
    filterHeadPosition?: FilterHeadPosition
}

export const Container = styled.div<ContainerProps>(
    ({ filterHeadPosition, isActive, isFilterSelected, theme }) => css`
        padding: 1.25rem 0 ${theme.spacing.small};
        display: flex;
        align-items: center;

        @media only screen and (max-width: ${tabletBreakpoint.min}px) {
            width: 100%;
            justify-content: space-between;
            padding: 0 1rem 1rem 1rem;
            box-sizing: border-box;
        }

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            cursor: pointer;

            ${filterHeadPosition === FilterHeadPosition.STANDARD_FILTER_LISTING &&
            css`
                padding: 0.5rem 0;
                display: flex;
                justify-content: space-between;
                align-items: center;
                font-weight: 600;
                font-size: 1rem;
                line-height: 1.375rem;
                color: #282828;
                user-select: none;
                width: 100%;

                & + .filter-content {
                    ${isActive && `display: block;`}
                }
            `}

            ${(filterHeadPosition === FilterHeadPosition.STANDARD_FILTER ||
                filterHeadPosition === FilterHeadPosition.STANDARD_FILTER_MAP) &&
            css`
                margin-left: ${theme.spacing.medium};
                display: inline-flex;
                border-radius: ${theme.typography.border.radius.xxLarge};
                flex-direction: row;
                background-color: ${theme.colors.white};
                font-size: ${theme.typography.font.size.medium};
                user-select: none;
                padding: 0.1875rem 0.4375rem 0.1875rem 0.6875rem;
                border: ${theme.typography.border.radius.xxxSmall} solid #0000001a;

                &:hover {
                    border: ${theme.typography.border.radius.xxxSmall} solid #2298da80;
                }

                ${(isActive || isFilterSelected) &&
                css`
                    background: #2298da14;
                    border: ${theme.typography.border.radius.xxxSmall} solid #2298da33;
                `}

                & + .filter-content {
                    ${isActive && `display: block;`}
                }
            `}
        }
    `,
)

export const ChevronDown = styled(ChevronDownIcon as AnyStyledComponent)(
    ({ theme }) => css`
        height: 2rem;
        width: 2rem;
    `,
)

export const ChevronUp = styled(ChevronDown)`
    transform: rotate(180deg);
`

export const NewTagContainer = styled.div<{ filterHeadPosition?: FilterHeadPosition }>(
    ({ filterHeadPosition, theme }) => css`
        display: flex;
        position: relative;
        margin-left: ${theme.spacing.xxSmall};
        background-color: ${theme.colors.tfwRedOpacity08};
        border-radius: ${theme.typography.border.radius.xSmall};
        padding: ${theme.spacing.xxxSmall} ${theme.spacing.xSmall};
        letter-spacing: 0.025rem;
        text-transform: uppercase;
        color: ${theme.colors.tfwRed};
        font-size: 0.5625rem;
        line-height: ${theme.typography.font.size.medium};

        ${(filterHeadPosition === FilterHeadPosition.STANDARD_FILTER ||
            filterHeadPosition === FilterHeadPosition.STANDARD_FILTER_MAP) &&
        css`
            display: none;
        `}
    `,
)

export const NewTagIcon = styled(NewTagStarIcon as AnyStyledComponent)`
    position: absolute;
    top: 0;
    right: 0;
    height: ${({ theme }) => theme.spacing.xSmall};
    width: ${({ theme }) => theme.spacing.xSmall};
`
export const Text = styled.div<{ filterHeadPosition?: FilterHeadPosition }>(
    ({ filterHeadPosition, theme }) => css`
        font: ${theme.typography.font.lato.weight.black} ${theme.typography.font.size.medium} /
            ${theme.typography.font.size.xLarge} ${theme.typography.font.family.latoVerdana};
        font-feature-settings: 'ordn' on;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            ${filterHeadPosition === FilterHeadPosition.STANDARD_FILTER_LISTING &&
            css`
                font-weight: 600;
                font-size: 1rem;
                max-width: unset;
                line-height: normal;
            `}

            ${(filterHeadPosition === FilterHeadPosition.STANDARD_FILTER ||
                filterHeadPosition === FilterHeadPosition.STANDARD_FILTER_MAP) &&
            css`
                font-weight: ${theme.typography.font.lato.weight.regular};
                font-size: ${theme.typography.font.size.small};
                max-width: 8.125rem;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            `}
        }
    `,
)
